import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import StoreProvider from "./providers/StoreProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, theme } from "antd";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { BrowserRouter } from "react-router-dom";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      staleTime: 5 * 60 * 1000, // Optional: 5 minutes (adjust as needed)
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

// Persist the QueryClient
persistQueryClient({
  queryClient,
  persister,
  maxAge: 1000 * 60 * 60 * 24,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <StoreProvider>
          <ConfigProvider
            theme={{
              token: {
                colorSplit: "#08453E", // for divider
                colorPrimary: "#009602", //  0D5D54
                colorPrimaryBg: "#0D5D54",
                colorBgContainer: "#08453E",
                colorBorder: "#009602",
                colorFillAlter: "#009602",
                // colorFillAlter: '#EFF2F3',
                colorText: "white",
                colorTextTertiary: "#FF9900",
                colorError: "white",
                colorTextDisabled: "#999",
              },
              components: {
                Checkbox: {
                  colorBgContainer: "white",
                  colorBgContainerDisabled: "#ccc",
                },
                Input: {
                  colorFillAlter: "08453E",
                  colorBorder: "#D5E0E3",
                  colorBgContainer: "white",
                  controlHeight: 50,
                  colorTextPlaceholder: "#8c8f8d",
                  colorText: "black",
                },
                InputNumber: {
                  colorFillAlter: "08453E",
                  colorBorder: "#D5E0E3",
                  colorBgContainer: "white",
                  controlHeight: 50,
                  colorText: "black",
                  colorTextPlaceholder: "#8c8f8d",
                },
                Select: {
                  colorBorder: "#D5E0E3",
                  colorBgContainer: "white",
                  controlHeight: 50,
                  colorText: "black",
                  colorTextPlaceholder: "#8c8f8d",
                },
                Button: {
                  colorPrimary: "#009602", //  0D5D54
                  colorBgContainer: "#FF9900",
                  colorBorder: "#FF9900",
                  defaultHoverBorderColor: "#FF9900",
                  // defaultHoverBg: 'red',
                  primaryShadow: "#009602",
                  colorText: "white",
                },
                Table: {
                  lineWidth: 1,
                  colorBgContainer: "white",
                  colorText: "#475156",
                  colorFillAlter: "#EEF3F8",
                  colorTextHeading: "#000",
                  rowSelectedBg: "#EEF3F8",
                },
                Pagination: {
                  colorBgContainer: "white",
                  colorText: "green",
                  colorWhite: "green",
                  // colorText: 'green'
                },
                Transfer: {
                  colorSplit: "#EEF3F8", // for divider
                  colorBgContainer: "#EEF3F8",
                  colorBorder: "#EEF3F8",
                  colorFillAlter: "blue",
                  // colorFillAlter: '#EFF2F3',
                  colorText: "black",
                },
                DatePicker: {
                  colorTextHeading: "#009602",
                  colorPrimaryBg: "#0D5D54",
                  colorBgBase: "red",
                  colorBgContainer: "white",
                  colorText: "black",
                  colorTextPlaceholder: "#8c8f8d",
                  controlHeight: 50,
                },
                Skeleton: {
                  colorFill: "#0D5D54",
                },
                Drawer: {
                  colorBgElevated: "#08453E",
                  colorBgLayout: "#08453E",
                },
                Collapse: {
                  headerBg: "transparent",
                  borderRadius: 0,
                  borderRadiusOuter: 0,
                  borderRadiusLG: 4,
                  borderRadiusSM: 4,
                  borderRadiusXS: 4,
                },
                Steps: {
                  colorText: "black",
                },
                Tabs: {
                  colorText: "black",
                  colorBgContainer: "white",
                  colorPrimaryBg: "red",
                  colorBgBase: "lightblue",
                },
              },
            }}
          >
            {/* <AuthProvider> */}
            <App />
            {/* </AuthProvider> */}
          </ConfigProvider>
        </StoreProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
